import { useState, useEffect } from 'react';
import callApi from '../index';

const useApi = (params) => {
	const [state, setState] = useState(null);
	useEffect(() => {
		if (params !== null) {
			const { apiPath, dataVector } = params;
			callApi(apiPath, dataVector)
				.then((res) => {
					setState({ response: res, error: false, success: true, ...params });
				})
				.catch((error) => {
					setState({ response: null, error: error, success: false, ...params });
				});
		}
	}, [params]);
	return state;
}

export default useApi;
